<template>
  <div>
    <h3 class="text-lg leading-6 pb-1 font-medium text-gray-900 border-b border-gray-200">
      {{title}}
    </h3>
    <form @submit.prevent="saveFilter">
      <div class="text-default">
        <div class="d-flex">
          <fg-input class="filter-select"
                    :label="$t('filters.tags.filterPopover.filter')">
            <el-select class="select-default"
                       :placeholder="$t('filters.tags.filterPopover.field')"
                       v-model="model.field"
                       filterable
                       value-key="field">

              <el-option v-for="field in fields.filters"
                         :key="field.label"
                         :label="$t(field.label)"
                         :value="field"
                         class="select-default"
              />
            </el-select>
          </fg-input>
          <fg-input class="filter-select" label="&nbsp;">
            <el-select class="select-default"
                       v-if="model.field && model.field.type"
                       :placeholder="$t('filters.tags.filterPopover.isOneOf')"
                       v-model="model.operator"
            >
              <el-option v-for="operator in allOperators[model.field.type] || allOperators.string"
                         :key="operator.name"
                         :label="operator.name"
                         :value="operator.value"
                         class="select-default"
              />
            </el-select>
          </fg-input>
          <div v-if="isBetweenOperator" class="d-flex">
            <fg-input class="filter-select" :label="$t('generic.min')"
                      key="min"
                      v-model="model.min"
                      :type="isIntegerField ? 'number': undefined"
                      :component="model.field && model.field.type === 'date' ? 'el-date-picker': undefined">
            </fg-input>
            <fg-input class="filter-select" :label="$t('generic.max')"
                      key="max"
                      v-model="model.max"
                      :type="isIntegerField ? 'number': undefined"
                      :component="model.field && model.field.type === 'date' ? 'el-date-picker': undefined">
            </fg-input>
          </div>
          <fg-input v-else
                    class="filter-select" label="&nbsp;"
                    v-model="model.values"
                    :type="isIntegerField ? 'number': undefined"
                    :component="model.field && model.field.type === 'date' ? 'el-date-picker': undefined">
            <el-select v-if="isAutocompleteField"
                       class="select-default"
                       v-model="model.values"
                       :placeholder="$t('filters.tags.filterPopover.values')"
                       remote
                       reserve-keyword
                       :multiple="isMultiple"
                       :remote-method="autocompleteSearch"
                       :loading="searchLoading"
                       @focus="autocompleteSearch('')"
                       default-first-option
                       filterable
            >
              <el-option v-for="field in fieldValues"
                         class="select-default"
                         :key="field.key"
                         :label="field.value"
                         :value="field.key"/>
            </el-select>
          </fg-input>
        </div>
        <div>
          <fg-input class="label__input"
                    :label="$t('filters.tags.filterPopover.label')"
                    :placeholder="$t('filters.tags.filterPopover.label')"
                    v-model="model.label"
          >
          </fg-input>
        </div>
        <div
          class="px-4 py-3 border-t rounded-b-lg -mx-3 -mb-3 border-gray-200 bg-gray-50 text-center sm:px-6 overflow-hidden">
          <submit-button outline @click="cancelFilter" type="info">
            {{$t('generic.cancel')}}
          </submit-button>
          <submit-button :disabled="!canSave"
                         native-type="submit"
                         class="ml-2">
            {{$t('generic.save')}}
          </submit-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Select, Option, DatePicker } from 'element-ui'
  import TypeAheadService from 'src/services/TypeAheadService'

  Vue.use(DatePicker)
  let operators = {
    IS: {
      name: 'is',
      value: 'IS'
    },
    IS_NOT: {
      name: 'is not',
      value: 'ISNOT'
    },
    IN: {
      name: 'in',
      value: 'IN'
    },
    NOT_IN: {
      name: 'not in',
      value: 'NOTIN'
    },
    LIKE: {
      name: 'like',
      value: 'LIKE'
    },
    LTE: {
      name: 'less than or equal',
      value: '<='
    },
    GTE: {
      name: 'greater than or equal',
      value: '>='
    },
    BETWEEN: {
      name: 'between',
      value: '><'
    }
  }
  export default {
    name: 'filter-popover-content',
    components: {
      ElSelect: Select,
      ElOption: Option
    },
    props: {
      title: String,
      filter: {
        type: Object,
        default: () => ({})
      },
      fields: {
        type: Object,
        default: () => ({})
      }
    },
    data: function () {
      return {
        allOperators: {
          string: [operators.IS, operators.IS_NOT, operators.LIKE],
          date: [operators.LTE, operators.GTE, operators.BETWEEN],
          integer: [operators.IS, operators.IS_NOT, operators.LTE, operators.GTE, operators.BETWEEN],
          multiselect: [operators.IS, operators.IS_NOT, operators.IN, operators.NOT_IN],
        },
        searchLoading: false,
        model: {
          field: null,
          operator: null,
          values: null,
          min: '',
          max: '',
          label: null,
          selected: true,
          valuesLabel: null
        },
        autoCompleteLimit: 20,
        fieldValues: []
      }
    },
    computed: {
      canSave () {
        if (this.isBetweenOperator) {
          return this.model.operator && (this.model.min || this.model.max)
        }
        return this.model.field && this.model.operator && this.model.values
      },
      isAutocompleteField () {
        return this.model.field && this.model.field.type === 'multiselect'
      },
      isIntegerField () {
        return this.model.field && this.model.field.type === 'integer'
      },
      isBetweenOperator () {
        return this.model.operator === operators.BETWEEN.value
      },
      isMultiple () {
        return this.model.operator === operators.IN.value || this.model.operator === operators.NOT_IN.value
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      cancelFilter () {
        this.$emit('cancel')
        this.resetModel()
      },
      resetModel () {
        this.model = {
          field: null,
          operator: null,
          values: null,
          label: null,
          selected: true
        }
      },
      async saveFilter () {
        if (!this.canSave) {
          return
        }
        this.$emit('save-filter', {
          ...this.model
        })
      },
      async autocompleteSearch (query) {
        let currentField = this.model.field
        if (['admins', 'not_admins', 'automatic'].includes(currentField.field)) {
          return
        }
        if (currentField.options) {
          this.fieldValues = []
          for (let key in currentField.options) {
            this.fieldValues.push({
              key,
              value: this.$t(currentField.options[key])
            })
          }
          return
        }
        // setup autocomplete here
        try {
          let res = await TypeAheadService.search({
            type: this.model.field.field,
            value: query
          })
          this.fieldValues = res.data
        } finally {
        }
      }
    },
    watch: {
      async 'model.field' (newVal, oldValue) {
        if (!newVal) {
          return
        }
        let operators = this.allOperators[newVal.type] || []
        if (!this.model.operator) {
          this.model.operator = operators[0].value
        }

        if (oldValue && oldValue.label !== newVal.label) {
          this.model.values = null
          this.model.label = this.$t(newVal.label)
        }
        if (!this.model.label) {
          this.model.label = this.$t(newVal.label)
        }
      },
      async 'model.values' (newVal) {
        if (newVal && Array.isArray(newVal) && this.model.operator === operators.BETWEEN.value) {
          this.model.min = newVal[0]
          this.model.max = newVal[1]
        }
        if (!this.fieldValues.length) {
          return
        }
        if (Array.isArray(newVal) && this.isMultiple) {
          this.model.valuesLabel = newVal.map(val => {
            return (this.fieldValues.find(f => f.key === val) || {}).value
          })
        } else {
          this.model.valuesLabel = (this.fieldValues.find(f => f.key === newVal) || {}).value
        }
      },
      'model.operator' (newVal) {
        if ((newVal === operators.IN.value || newVal === operators.NOT_IN.value) && !Array.isArray(this.model.values)) {
          this.model.values = []
        }
      },
      filter: {
        immediate: true,
        handler: function (newVal) {
          this.model = {
            ...this.model,
            ...newVal
          }

          if (this.model.values) {
            this.autocompleteSearch('')
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .label__input {
    max-width: 177px;
  }

  .filter-select,
  .label__input {
    margin-right: 15px;

    input,
    input:focus,
    input:hover {
      color: $default-color;
    }

    input::placeholder {
      color: $default-color !important;
    }
  }
</style>
